var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbcCrossmarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32803 0.0967079C10.6818 -0.0197899 13.2195 1.3466 14.9412 4.19588C16.2213 6.70991 16.233 9.23066 14.9765 11.7582C13.7358 13.9199 11.8929 15.2686 9.44771 15.8043C6.24017 16.2627 3.6318 15.2321 1.62256 12.7123C0.0123686 10.3813 -0.329133 7.87235 0.598043 5.18534C1.59095 2.77863 3.32791 1.18255 5.80893 0.397078C6.31277 0.258261 6.81917 0.158139 7.32803 0.0967079Z",
    fill: "#FAECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03 4.65529C5.20354 4.63985 5.36838 4.66928 5.5246 4.74364C6.3435 5.56866 7.16784 6.38733 7.99756 7.19961C8.82727 6.38733 9.65161 5.56866 10.4705 4.74364C10.9474 4.55218 11.2418 4.70529 11.3537 5.20303C11.3531 5.32257 11.3237 5.43449 11.2654 5.53873C10.4406 6.35786 9.62215 7.18243 8.8101 8.01237C9.62215 8.84231 10.4406 9.66688 11.2654 10.486C11.4585 10.9832 11.2937 11.2776 10.7708 11.3695C10.6603 11.3755 10.5601 11.3461 10.4705 11.2811C9.65161 10.4561 8.82727 9.63741 7.99756 8.82514C7.16784 9.63741 6.3435 10.4561 5.5246 11.2811C5.02757 11.4743 4.73318 11.3094 4.6414 10.7864C4.63536 10.6758 4.66478 10.5757 4.72972 10.486C5.55452 9.66688 6.37296 8.84231 7.18501 8.01237C6.37296 7.18243 5.55452 6.35786 4.72972 5.53873C4.54919 5.14649 4.64927 4.85198 5.03 4.65529Z",
    fill: "#FD2D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbcCrossmarkLight);
export default __webpack_public_path__ + "static/media/cbc-crossmark-light.e7faa749fcea064c977a7947d314e9c1.svg";
export { ForwardRef as ReactComponent };